"use client";

import React from "react";
import { Phone, Navigation, Zap } from "lucide-react";
const HERO_IMAGE = "https://upward-sunbeam.10web.cloud/wp-content/uploads/2026/05/hero-4.png";
const GOOGLE_REVIEW_LINK = "https://g.page/r/CcSUPDuiDPKPEAI/review";
const YELP_REVIEW_LINK = "https://www.yelp.com/writeareview/biz/0FtPEoz4hY7Pq_kCq-ccaw?return_url=%2Fbiz%2F0FtPEoz4hY7Pq_kCq-ccaw&review_origin=biz-details-war-button";
export default function NovaHeroPremiumFinal() {
  return <section className="relative overflow-hidden bg-white">
      {/* BACKGROUND */}
      <div className="absolute inset-0 z-0">
        <img src={HERO_IMAGE} alt="Nova Tire Center tire service" className="
            w-full
            h-full
            object-cover
            object-[72%_center]
            md:object-[78%_center]
          " />

        <div className="
            absolute inset-0
            bg-gradient-to-b
            from-white/84
            via-white/62
            to-black/16
            md:hidden
          " />

        <div className="
            hidden md:block
            absolute inset-0
            bg-gradient-to-r
            from-white from-[0%]
            via-white/80 via-[26%]
            via-white/30 via-[42%]
            to-transparent to-[60%]
          " />

        <div className="absolute inset-0 bg-gradient-to-b from-white/5 via-transparent to-black/10" />
      </div>

      {/* DESKTOP LINES */}
      <div className="absolute z-10 left-[46%] top-0 h-full w-[12px] bg-[#0B4DBA]/95 -skew-x-[13deg] shadow-[0_0_26px_rgba(11,77,186,0.28)] hidden lg:block" />
      <div className="absolute z-10 left-[45%] top-[40px] h-[300px] w-[9px] bg-[#FF5A00]/90 -skew-x-[13deg] shadow-[0_0_22px_rgba(255,90,0,0.25)] hidden lg:block" />
      <div className="absolute z-10 left-[46.9%] top-0 h-full w-[3px] bg-white/50 -skew-x-[13deg] hidden lg:block" />

      {/* CONTENT */}
      <div className="relative z-20 max-w-[1180px] mx-auto px-4 lg:px-6">
        <div className="min-h-[520px] md:min-h-[470px] flex items-start md:items-center">
          <div className="
              max-w-[520px]
              ml-0
              lg:ml-[-70px]
              pt-14
              pb-10
              md:py-8
            ">
            {/* BADGE */}
            <div className="
                inline-flex
                items-center
                gap-2
                bg-white/92
                border border-[#DDE7F5]
                shadow-[0_10px_25px_rgba(7,27,58,0.08)]
                px-4
                md:px-5
                py-2.5
                md:py-3
                mb-5
              ">
              <Zap className="w-4 h-4 text-[#0B4DBA]" />
              <span className="
                  text-[#0B4DBA]
                  text-[11px]
                  md:text-[13px]
                  font-black
                  uppercase
                  tracking-[0.04em]
                ">
                Fast. Reliable. Local.
              </span>
            </div>

            {/* TITLE */}
            <h1 className="uppercase italic tracking-[-0.055em] leading-[0.86]">
              <span className="block text-black font-black text-[66px] sm:text-[72px] md:text-[92px] lg:text-[100px]">
                Fast
              </span>

              <span className="
                  block
                  text-[#0B4DBA]
                  font-black
                  text-[36px]
                  sm:text-[40px]
                  md:text-[52px]
                  lg:text-[58px]
                  drop-shadow-[2px_2px_0px_rgba(0,0,0,0.92)]
                  mt-1
                ">
                Tire Service
              </span>

              <span className="
                  block
                  text-black
                  font-black
                  text-[22px]
                  sm:text-[24px]
                  md:text-[28px]
                  lg:text-[31px]
                  tracking-[0.05em]
                  mt-2
                  md:mt-3
                  not-italic
                ">
                Los Angeles
              </span>
            </h1>

            {/* ORANGE LINE */}
            <div className="
                w-[74px]
                md:w-[84px]
                h-[3px]
                md:h-[4px]
                bg-[#FF5A00]
                mt-5
                mb-10
                md:mb-6
                shadow-[0_6px_16px_rgba(255,90,0,0.28)]
              " />

            {/* BUTTONS */}
            <div className="mt-0 flex flex-col gap-3 w-full max-w-[310px]">
              <a href="tel:+14243138474" className="
                  inline-flex
                  items-center
                  justify-center
                  gap-2.5
                  bg-[#FF5A00]
                  hover:bg-[#E94E00]
                  text-white
                  px-5
                  md:px-8
                  py-[14px]
                  md:py-[16px]
                  w-full
                  font-black
                  uppercase
                  text-[15px]
                  md:text-[16px]
                  rounded-[10px]
                  shadow-[0_14px_28px_rgba(255,90,0,0.28)]
                  border border-white/20
                  transition
                ">
                <Phone className="w-4 h-4" />
                Call Now
              </a>

              <a href="https://www.google.com/maps/dir/?api=1&destination=34.05439451680097%2C-118.37986175094777" target="_blank" rel="noopener noreferrer" className="
                  inline-flex
                  items-center
                  justify-center
                  gap-2.5
                  bg-white/92
                  backdrop-blur-md
                  border-2 border-[#0B4DBA]
                  text-[#0B4DBA]
                  hover:bg-[#0B4DBA]
                  hover:text-white
                  px-5
                  md:px-8
                  py-[14px]
                  md:py-[16px]
                  w-full
                  font-black
                  uppercase
                  text-[15px]
                  md:text-[16px]
                  rounded-[10px]
                  shadow-[0_12px_24px_rgba(7,27,58,0.12)]
                  transition
                ">
                <Navigation className="w-4 h-4" />
                Get Directions
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* DESKTOP REVIEW BAR */}
      <div className="
          hidden
          md:block
          relative
          z-30
          bg-[#F7F9FC]
          border-t border-[#E3E7EF]
          shadow-[0_-10px_30px_rgba(7,27,58,0.05)]
        ">
        <div className="max-w-[1180px] mx-auto px-6 py-4">
          <div className="flex items-center justify-center gap-0 max-w-[760px] mx-auto bg-white border border-[#E3E7EF] rounded-[14px] shadow-[0_12px_28px_rgba(7,27,58,0.08)] overflow-hidden">
            {/* GOOGLE */}
            <a href={GOOGLE_REVIEW_LINK} target="_blank" rel="noopener noreferrer" className="flex-1 flex flex-col items-center justify-center text-center py-4 transition hover:bg-[#F7F9FC]">
              <div className="flex items-center gap-1.5">
                <span className="text-[#0B4DBA] font-black text-[22px]">G</span>
                <span className="text-black font-black text-[16px]">4.9</span>
                <span className="text-[#FFB400] text-[14px]">★★★★★</span>
              </div>
              <span className="text-[11px] text-[#5B6575] font-semibold uppercase tracking-wide mt-1">
                Google Reviews
              </span>
            </a>

            <div className="w-px h-[44px] bg-[#D7DFEC]" />

            {/* TOP 3 - CENTER */}
            <div className="flex-1 flex flex-col items-center justify-center text-center py-4">
              <div className="text-black font-black text-[16px] leading-none">
                Top 3
              </div>
              <span className="text-[11px] text-[#5B6575] font-semibold uppercase tracking-wide mt-1">
                Tire Shop
              </span>
              <span className="text-[10px] text-[#5B6575] uppercase">
                Central LA
              </span>
            </div>

            <div className="w-px h-[44px] bg-[#D7DFEC]" />

            {/* YELP */}
            <a href={YELP_REVIEW_LINK} target="_blank" rel="noopener noreferrer" className="flex-1 flex flex-col items-center justify-center text-center py-4 transition hover:bg-[#F7F9FC]">
              <div className="flex items-center gap-1.5">
                <span className="text-[#FF5A00] font-black text-[22px]">Y</span>
                <span className="text-black font-black text-[16px]">4.8</span>
                <span className="text-[#FFB400] text-[14px]">★★★★★</span>
              </div>
              <span className="text-[11px] text-[#5B6575] font-semibold uppercase tracking-wide mt-1">
                Yelp Reviews
              </span>
            </a>
          </div>
        </div>
      </div>

      {/* MOBILE REVIEW BAR */}
      <div className="
          relative
          z-30
          bg-[#F7F9FC]
          border-t border-[#E3E7EF]
          md:hidden
        ">
        <div className="flex items-center justify-between gap-2 px-3 py-4">
          {/* GOOGLE */}
          <a href={GOOGLE_REVIEW_LINK} target="_blank" rel="noopener noreferrer" className="flex flex-col items-center text-center min-w-0 flex-1 transition duration-200 hover:opacity-80 hover:-translate-y-[1px]">
            <div className="flex items-center gap-1">
              <span className="text-[#0B4DBA] font-black text-[20px]">G</span>
              <span className="text-black font-black text-[14px]">4.9</span>
              <span className="text-[#FFB400] text-[12px]">★★★★★</span>
            </div>
            <span className="text-[10px] text-[#5B6575] font-semibold uppercase tracking-wide mt-1">
              Google Reviews
            </span>
          </a>

          <div className="w-px h-[36px] bg-[#D7DFEC]" />

          {/* TOP 3 - CENTER */}
          <div className="flex flex-col items-center text-center min-w-0 flex-1">
            <div className="text-black font-black text-[14px] leading-none">
              Top 3
            </div>
            <span className="text-[10px] text-[#5B6575] font-semibold uppercase tracking-wide mt-1">
              Tire Shop
            </span>
            <span className="text-[9px] text-[#5B6575] uppercase">
              Central LA
            </span>
          </div>

          <div className="w-px h-[36px] bg-[#D7DFEC]" />

          {/* YELP */}
          <a href={YELP_REVIEW_LINK} target="_blank" rel="noopener noreferrer" className="flex flex-col items-center text-center min-w-0 flex-1 transition duration-200 hover:opacity-80 hover:-translate-y-[1px]">
            <div className="flex items-center gap-1">
              <span className="text-[#FF5A00] font-black text-[20px]">Y</span>
              <span className="text-black font-black text-[14px]">4.8</span>
              <span className="text-[#FFB400] text-[12px]">★★★★★</span>
            </div>
            <span className="text-[10px] text-[#5B6575] font-semibold uppercase tracking-wide mt-1">
              Yelp Reviews
            </span>
          </a>
        </div>
      </div>
    </section>;
}